
export interface Moat {
  icon: string;
  name: string;
  englishName: string;
  question: string;
}

export const moats: Moat[] = [
  {
    icon: "🧱",
    name: "流程能力",
    englishName: "Process Power",
    question: "如果我今天重來一次，是否能用同樣的流程再複製出一樣的成果？",
  },
  {
    icon: "🔒",
    name: "獨佔資源",
    englishName: "Cornered Resource",
    question: "別人要花幾年才能得到我今天擁有的「內隱知識」？",
  },
  {
    icon: "🧩",
    name: "轉換成本",
    englishName: "Switching Cost",
    question: "我的客戶／觀眾離開我之後，會「想我」嗎？",
  },
  {
    icon: "⚔️",
    name: "反向定位",
    englishName: "Counter-Positioning",
    question: "我的存在方式，會讓別人「不敢」模仿嗎？",
  },
  {
    icon: "🌍",
    name: "網絡效應",
    englishName: "Network Effect",
    question: "我的價值會因為他人參與而「指數增長」嗎？",
  },
  {
    icon: "🧠",
    name: "規模經濟",
    englishName: "Scale Economies",
    question: "我的時間單位報酬率（ROTH：Return on Time Hour）是否在上升？",
  },
  {
    icon: "🌟",
    name: "品牌",
    englishName: "Brand",
    question: "當人們提到我的名字時，他們聯想到什麼？",
  },
];

export const interpretations: { [key: string]: string } = {
  "4.0-5.0": "你已在該維度形成結構性防禦。",
  "3.0-3.9": "持續發展中，潛力巨大，但尚未穩固。", // Placeholder
  "2.0-2.9": "處於開發階段，需明確行動計畫。",
  "0.0-1.9": "幾乎無護城河，容易被取代。",
};
